<form [formGroup]="formGroup" class="walk-test">
  @if (pageTitle) {
    <div class="walk-test-page-header">
      <b>{{ getQuestionTitle(pageTitle) }}</b>
      @if (getQuestionInstruction(pageTitle)) {
        <div class="walk-test-instruction">
          {{ getQuestionInstruction(pageTitle) }}
        </div>
      }
    </div>
  }
  @for (element of elements; track element.name) {
    @if (element.type === "section") {
      <div class="section">
        <b class="section-title">{{ getQuestionTitle(element.title) }}</b>
        @if (getQuestionInstruction(element.title)) {
          <div class="walk-test-instruction">
            {{ getQuestionInstruction(element.title) }}
          </div>
        }
      </div>
    }
    @if (element.type === "text") {
      <div class="walk-test-row">
        <div>
          <div class="walk-test-q-title">
            {{ getQuestionTitle(element.title) }}
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="walk-test-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div>
          <input
            type="text"
            inputmode="decimal"
            class="walk-test-input"
            [formControlName]="element.name"
          />
          @if (isInvalid(element)) {
            <div class="walk-test-error">
              {{ "Enter a time above 0" | translate }}
            </div>
          }
        </div>
      </div>
    }
    @if (getSpeedAfter(element); as speed) {
      <div class="walk-test-speed">
        <div class="walk-test-q-title">{{ getSpeedTitle(speed) }}</div>
        <div class="walk-test-speed-value">
          {{ getSpeedDisplay(speed) }} m/s
        </div>
      </div>
    }
    @if (element.type === "radiogroup") {
      <div class="walk-test-row">
        <div>
          <div class="walk-test-q-title">
            {{ getQuestionTitle(element.title) }}
          </div>
          @if (getQuestionInstruction(element.title)) {
            <div class="walk-test-instruction">
              {{ getQuestionInstruction(element.title) }}
            </div>
          }
        </div>
        <div class="walk-test-group">
          @for (choice of element.choices; track choice.value) {
            <label class="walk-test-option">
              <input
                type="radio"
                [formControlName]="element.name"
                [value]="choice.value"
                (click)="onRadioClick(element.name, choice.value)"
              />
              <span>{{ choice.text }}</span>
            </label>
          }
        </div>
      </div>
    }
  }
</form>
